//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Swal from 'sweetalert2';
import Dropzone from 'dropzone';
export default {
  name: 'InputFile',
  props: {
    url: {
      type: String,
      default: '/',
      required: true
    },
    csrf: {
      type: String,
      default: null,
      required: false
    },
    start: {
      type: Boolean,
      default: false,
      required: false
    },
    params: {
      type: Object,
      default: () => {},
      required: false
    }
  },

  data() {
    return {
      errors: null,
      csrfSet: false,
      response: null
    };
  },

  mounted() {
    const self = this;
    this.uploader = new Dropzone(this.$refs.target, {
      url: this.url,
      // 8 hours
      timeout: 28800000,
      // In megabytes.
      maxFilesize: 20,
      uploadMultiple: true,
      parallelUploads: 10,
      autoProcessQueue: false,

      init() {
        this.on('addedfile', function (file) {
          // Remove a file when clicked from the preview.
          file.previewElement.addEventListener('click', () => {
            this.removeFile(file);
          });
          self.$emit('result', {
            status: 'added',
            files: this.files
          });
        }); // All files in the queue finished uploading.

        this.on('queuecomplete', file => {
          self.spinner.close();
          self.$emit('result', {
            status: 'done',
            response: self.response,
            errors: self.errors
          });
        }); // A single file upload has completed. The upload
        // was either a success or a failure.

        this.on('complete', file => {
          self.$emit('result', {
            status: 'complete',
            file
          });
        });
        this.on('sending', (file, xhr, formData) => {
          if (!self.csrfSet) {
            xhr.setRequestHeader('X-CSRF-TOKEN', self.csrf);
          }

          self.csrfSet = true;
        }); // A single file upload was a success.

        this.on('success', (file, response) => {
          self.response = response; // self.$emit('result', {
          //     status: 'success',
          //     response,
          //     file,
          // });
        }); // A single file upload was a failure.

        this.on('error', (file, errors, xhr) => {
          self.errors = errors; // self.$emit('result', {
          //     status: 'failed',
          //     errors,
          //     xhr,
          // });
        });
      },

      params() {
        return { ...self.params
        };
      }

    });
    this.spinner = Swal.mixin({
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      heightAuto: false
    });
  },

  beforeDestroy() {
    if (this.uploader) {
      this.uploader.destroy();
    }

    this.uploader = null;
  },

  watch: {
    start(startUploading) {
      if (startUploading) {
        if (this.uploader.files.length > 0) {
          this.spinner.fire({
            title: 'Uploading the file(s)...',
            html: '<i class="fas fa-5x fa-cog fa-spin"></i>'
          });
          this.uploader.processQueue();
        } else {
          // There are no files to upload.
          this.$emit('result', {
            status: 'done',
            response: this.response,
            errors: this.errors
          });
        }
      }
    }

  }
};